import {
  WireCoverageOptionType,
  WirePremium,
} from 'scenes/common/api/quote/types';
import { YesNoAnswer } from 'scenes/common/types';

import { WireMotorQuotePayload } from '../types';

export const findSelectedExtras = (
  premiums: WirePremium[],
  coverageId: string
) =>
  premiums.filter(
    (premium) =>
      premium.id.startsWith(`${coverageId}-`) &&
      !premium.inclusion &&
      premium.selected
  );

export const toCoverForDriversUnder25 = (
  quote: WireMotorQuotePayload
): YesNoAnswer =>
  quote.premiums.find(
    (premium) =>
      premium.name === WireCoverageOptionType.Under25 && premium.selected
  )
    ? YesNoAnswer.Yes
    : YesNoAnswer.No;
